/* eslint-disable no-console */
import type { KeywordDefinition, SchemaValidateFunction } from 'ajv';
import { isUpperLimit, isOverDeadLine } from 'models';
import { SingleSelectionProperty } from 'shared';
import { SingleSelectionValueForValidation } from '../../shared';

const KEYWORD = 'registrationLimit';

const validate: SchemaValidateFunction = (
  schema: SingleSelectionProperty['registrationLimit'],
  data: SingleSelectionValueForValidation,
  _,
) => {
  if (!schema || data.value == null) {
    return true;
  }

  validate.errors = [];
  const {
    upperLimitErrorMessage,
    registrationDeadlineErrorMessage,
    limits,
    currentTime,
  } = schema;

  const limit = limits.find((l) => l.value === data.value);
  if (limit == null || limit.isAnswered) {
    return true;
  }

  if (isUpperLimit(limit)) {
    validate.errors.push({
      keyword: KEYWORD,
      params: { keyword: KEYWORD },
      message: upperLimitErrorMessage,
    });
    return false;
  }
  if (isOverDeadLine(limit, currentTime)) {
    validate.errors.push({
      keyword: KEYWORD,
      params: { keyword: KEYWORD },
      message: registrationDeadlineErrorMessage,
    });
  }
  return validate.errors.length === 0;
};

export const registrationLimit: KeywordDefinition = {
  keyword: KEYWORD,
  type: 'object',
  validate,
};
